import { FPageBlock } from '../../mdl/f-page-block';
import { $el } from '../../ui/elements';
import { $form } from '../../y/form';
import { EDBlockSpec, EDBlock } from '../block';
import { EDBlockContainer } from '../editor';

export const ed_page_video_block: EDBlockSpec<FPageBlock> = {
    key: 'video',
    editor_block: class extends EDBlock {
        constructor(container: EDBlockContainer) {
            const properties = $el.DIV('l-form', [
            ]);

            super($form({}), container, 'Video', properties);

            this.classList.add('blk-video');
            this.ui_add([
            ]);
        }
    }
};
